import styled from 'styled-components';

export const SearchBarStyled = styled.div`
  background-color: #000;
  margin: 5px 0 0;
  color: #fff;
  padding: 15px 15px 10px;

  .row {
    justify-content: center;
  }

  select,
  input {
    padding: 2px 12px;
    margin-bottom: 5px;
  }

  #showPrice {
    text-align: right;
    font-weight: bold;
  }
`;
